module.exports = __webpack_public_path__ + "static/media/1.934e21b2.gif";